<div class="flex justify-center bg-gray-100 overflow-hidden pt-20 md:pt-0">
  <div class="container">
    <section
      class="flex min-h-[85vh] md:h-[85vh] py-12 md:py-0 bg-gray-100 md:px-12 lg:px-20"
    >
      <div
        class="flex flex-col-reverse items-center w-full gap-10 lg:flex-row lg:gap-16 my-auto"
      >
        <!-- Left Content -->
        <div
          class="flex flex-col px-6 md:px-0 items-start w-full gap-6 text-center lg:text-left md:w-1/2"
        >
          <h1
            class="text-4xl font-extrabold leading-tight text-gray-900 sm:text-6xl lg:text-7xl tracking-tight"
          >
            Custom <span class="text-[var(--primary)]">Merchandise</span>
          </h1>
          <p class="text-lg md:text-xl text-gray-600 max-w-lg leading-relaxed">
            Personalized handcrafted resin key tags with glitter & initial letters.
          </p>

          <div
            class="flex gap-4 mt-2 sm:flex-row w-full justify-center lg:justify-start"
          >
            <button
              (click)="getStart()"
              class="px-8 py-3.5 cursor-pointer bg-[var(--primary)] text-white text-sm md:text-lg font-semibold rounded-xl hover:bg-gray-900 transition duration-300"
            >
              Get Started
            </button>
            <button
              routerLink="/products"
              class="px-8 py-3.5 cursor-pointer border-2 border-[var(--primary)] text-[var(--primary)] text-sm md:text-lg font-semibold rounded-xl hover:bg-[var(--primary)] hover:text-white transition duration-300"
            >
              Explore Shop
            </button>
          </div>
        </div>

        <!-- Right Product Showcase (Isolated Product Image Without Background Container) -->
        <div
          class="relative w-full h-[350px] sm:h-[450px] md:h-[500px] flex items-center justify-center overflow-hidden md:w-1/2"
        >
          @for (slide of slides; track $index; let i = $index) {
            <img
              [src]="slide.image"
              (error)="onImageError($event, i)"
              [alt]="slide.title"
              class="absolute max-h-full max-w-full object-contain transition-all duration-700 ease-in-out hover:scale-105"
              [class.opacity-100]="i === currentIndex"
              [class.scale-100]="i === currentIndex"
              [class.opacity-0]="i !== currentIndex"
              [class.scale-95]="i !== currentIndex"
              [class.pointer-events-none]="i !== currentIndex"
            />
          }
        </div>
      </div>
    </section>
  </div>
</div>
